module.exports = __webpack_public_path__ + "static/gallery03-8157141afd689a3d725db446ec074f29.jpg";